import React from "react"
import IntroSection from "../components/IntroSection";
import UISolutions from "../components/UISolutions";
import BlueSectionDivider from "../components/BlueSectionDivider";
import UIProcess from "../components/UIProcess";
import CustomerTestimonials from "../components/CustomerTestimonials";
import WebflowSection from "../components/WebflowSection";
import UIBenefits from "../components/UIBenefits";
import UIAwards from "../components/UIAwards";
import CountriesSection from "../components/CountriesSection";
import UIReimagine from "../components/UIReimagine";
import UIProjects from "../components/UIProjects";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import UIFaq from "../components/UIFaq";
import UIResources from "../components/UIResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const UI_UX =()=>{
    return(
        <div>
            <IntroSection title="UI & UX DESIGN" paragraph="Addressing your users’ needs with user-centric interfaces." backgroundImage="/images/ui-bg.webp"/>
            <UISolutions para1 = "Our expertise covers an array of areas, from simpler projects such as website building to highly complex applications." para2 = "Our user experience design services provides you with the right tools and resources to guide you through the process that is developing a web-based solution, whether you are a startup looking to develop an MVP, a scale-up looking to improve your product, or an enterprise scaling your website or digital capabilities."/>
            <BlueSectionDivider/>
            <UIProcess/>
            
            <WebflowSection/>
            <UIBenefits/>
            
            <BlueSectionDivider/>
            <CountriesSection/>
            <UIReimagine/>
            <BlueSectionDivider/>
            <UIProjects/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <UIFaq/>
            <BlueSectionDivider/>
          
           <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )

}
export default UI_UX;